import vars from '@/config/vars';
import { ENDPOINTS } from '@/helpers/enums';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { v4 as uuidv4 } from 'uuid';

const method = 'post';

const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: vars.request.baseURL,
    timeout: vars.request.timeout,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      const { token, refreshToken } = getState().auth;

      headers.set('x-correlationId', uuidv4());
      headers.set('x-client-platform', 'web');
      // eslint-disable-next-line
      headers.set('x-client-version', __VERSION__);
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('X-Refresh-Token', refreshToken);
      }

      return headers;
    },
  }),

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.login, method, body }),
    }),
    otp: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.otp, method, body }),
    }),
    resendOtp: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.otpResend, method, body }),
    }),
    retrieval: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.retrieval, method, body }),
    }),
    sendEmail: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.otpSend, method, body }),
    }),
    getOfferById: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.offer, method, body }),
    }),
    createOrUpdate: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.createUpdate, method, body }),
    }),
    getPaymentLink: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.createProfile, method, body }),
    }),
    finishProcess: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.finish, method, body }),
    }),
    getSummeryfile: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.fileGet, method, body }),
    }),
    getCounselorList: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.counselorList, method, body }),
    }),
    counselorList: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.counselorList, method, body }),
    }),
    meetingSlots: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.meetingSlots, method, body }),
    }),
    meetingCreate: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.meetingCreate, method, body }),
    }),
    approveTermsOfUse: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.approveTermsOfUse, method, body }),
    }),
    getClientById: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.getClientById, method, body }),
    }),
    createLead: builder.mutation({
      query: (body) => ({ url: ENDPOINTS.leadCreate, method, body }),
    }),
  }),
});

export default api;

export const {
  useLoginMutation,
  useOtpMutation,
  useRetrievalMutation,
  useSendEmailMutation,
  useGetOfferByIdMutation,
  useCreateOrUpdateMutation,
  useGetPaymentLinkMutation,
  useFinishProcessMutation,
  useGetSummeryfileMutation,
  useResendOtpMutation,
  useCounselorListMutation,
  useMeetingSlotsMutation,
  useMeetingCreateMutation,
  useApproveTermsOfUseMutation,
  useGetClientByIdMutation,
  useCreateLeadMutation,
} = api;
